import React, { FC, ReactNode, useMemo } from 'react';
import { OutlinedInput } from '@material-ui/core';
import { useStyles } from '../styles';

interface Props {
  type?: string;
  value: any;
  onChange: (value: any) => void;
  inputProps?: any;
  className?: string;
  placeholder?: string;
  endAdornment?: ReactNode;
  startAdornment?: ReactNode;
  onKeyPress?: (event: any) => void;
}

export const InputControl: FC<Props> = ({ type, value, className, onChange, inputProps, placeholder, endAdornment, startAdornment, onKeyPress }) => {
  const classes = useStyles();

  const props = useMemo(() => ({ ...inputProps }), [inputProps]);

  return (
    <OutlinedInput
      autoComplete="off"
      type={type || 'text'}
      className={`${classes.inputField} ${className}`}
      value={value}
      inputProps={props}
      placeholder={placeholder}
      onChange={onChange}
      endAdornment={endAdornment}
      onKeyPress={onKeyPress}
      startAdornment={startAdornment}
    />
  );
};
